'use client';

/**
 * The composer's single right-hand action.
 *
 * While busy it is Stop, and Stop is deliberately ENABLED even though the rest
 * of the composer is disabled — a slow generation has to be abortable.
 */

import React from 'react';
import { ArrowUp, Square } from 'lucide-react';

export function ComposerSubmitButton({
  isBusy,
  canSend,
  onStop,
}: {
  isBusy: boolean;
  canSend: boolean;
  onStop?: () => void;
}) {
  if (isBusy && onStop) {
    return (
      <button
        type="button"
        onClick={onStop}
        className="inline-flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full bg-destructive text-destructive-foreground transition-opacity hover:opacity-90"
        aria-label="Stop generating"
        title="Stop generating"
      >
        <Square className="h-4 w-4" aria-hidden />
      </button>
    );
  }
  return (
    <button
      type="submit"
      disabled={!canSend}
      aria-label="Send message"
      className="inline-flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full bg-primary text-primary-foreground transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:cursor-not-allowed disabled:opacity-40"
    >
      <ArrowUp className="h-5 w-5" aria-hidden />
    </button>
  );
}
